import React from 'react'
import { compose, withState, withHandlers } from 'recompose'
import Radio from '@mui/material/Radio'
import DatePicker from '../DatePicker'
import Filter from './Filter'
import FilterActions from './FilterActions'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import { withStyles } from '@mui/styles'
import CardContent from '@mui/material/CardContent'

export const getTimeFrameHeader = timeFrame => {
	switch (timeFrame.type) {
		case 'any':
			return 'Any'
		case 'last7Days':
			return 'Last 7 days'
		case 'last30Days':
			return 'Last 30 days'
		case 'custom':
			if (!timeFrame.from && !timeFrame.to) return 'Any'
			let from = timeFrame.from ? timeFrame.from.format('l HH:mm') : '--'
			let to = timeFrame.to ? timeFrame.to.format('l HH:mm') : '--'
			return 'From ' + from + ' to ' + to
		default:
			return 'Unknown timeframe'
	}
}

const styles = {
	formLabelRoot: {
		height: '25px',
	},
}

export const TimeFrameFilter = ({ search, timeFrame, setTimeFrame, onSave, onCancel, classes }) => (
	<Filter
		filterObj={search.filter.timeFrame}
		filterState={timeFrame}
		setFilterState={setTimeFrame}
		title="Timeframe"
		subtitle={getTimeFrameHeader(search.filter.timeFrame)}
		content={
			<CardContent style={{ padding: '0px' }}>
				<div style={{ padding: '31px 44px 39px', borderTopRightRadius: '0px', borderTopLeftRadius: '0px' }}>
					<p style={{ margin: '0px 0px 15px' }}>Select date range</p>
					<RadioGroup>
						<FormControlLabel
							classes={{ root: classes.formLabelRoot }}
							value="any"
							control={
								<Radio
									value="any"
									checked={timeFrame.type === 'any'}
									label="Any"
									style={{ padding: '0px 12px' }}
									onClick={() => setTimeFrame({ ...timeFrame, type: 'any' })}
								/>
							}
							label="Any"
						/>
						<FormControlLabel
							classes={{ root: classes.formLabelRoot }}
							value="last7Days"
							control={
								<Radio
									value="last7Days"
									checked={timeFrame.type === 'last7Days'}
									label="Last 7 days"
									style={{ padding: '0px 12px' }}
									onClick={() => setTimeFrame({ ...timeFrame, type: 'last7Days' })}
								/>
							}
							label="Last 7 days"
						/>
						<FormControlLabel
							classes={{ root: classes.formLabelRoot }}
							value="last30Days"
							control={
								<Radio
									value="last30Days"
									checked={timeFrame.type === 'last30Days'}
									label="Last 30 days"
									style={{ padding: '0px 12px' }}
									onClick={() => setTimeFrame({ ...timeFrame, type: 'last30Days' })}
								/>
							}
							label="Last 30 days"
						/>
						<FormControlLabel
							classes={{ root: classes.formLabelRoot }}
							value="custom"
							control={
								<Radio
									value="custom"
									checked={timeFrame.type === 'custom'}
									label="Custom"
									style={{ padding: '0px 12px' }}
									onClick={() => setTimeFrame({ ...timeFrame, type: 'custom' })}
								/>
							}
							label="Custom"
						/>
					</RadioGroup>
					<div style={{ paddingLeft: '34px', overflow: 'hidden' }}>
						<div style={{ width: '100%' }}>
							<DatePicker
								value={timeFrame.from}
								disabled={timeFrame.type !== 'custom'}
								label="from"
								onChange={date => setTimeFrame({ ...timeFrame, from: date })}
							/>
						</div>
						<div style={{ width: '100%' }}>
							<DatePicker
								value={timeFrame.to}
								disabled={timeFrame.type !== 'custom'}
								label="to"
								onChange={date => setTimeFrame({ ...timeFrame, to: date })}
							/>
						</div>
					</div>
				</div>
				<FilterActions
					expanded={timeFrame.expanded}
					primaryLabel="Save"
					primaryAction={onSave}
					secondaryLabel="Cancel"
					secondaryAction={onCancel}
				/>
			</CardContent>
		}
	/>
)

const enhance = compose(
	withState('timeFrame', 'setTimeFrame', ownProps => {
		if(ownProps.search.filter.timeFrame.from && ownProps.search.filter.timeFrame.to){
			return ownProps.search.filter.timeFrame
		}
		return {...ownProps.search.filter.timeFrame, from: null, to: null}
	}),
	withHandlers({
		onSave: props => () => {
			let updated = {
				...props.search,
				filter: { ...props.search.filter, timeFrame: { ...props.timeFrame, expanded: false } },
			}
			props.onUpdate(updated)
			props.setTimeFrame(updated.filter.timeFrame)
		},
		onCancel: props => () => {
			props.setTimeFrame({ ...props.search.filter.timeFrame, expanded: false })
		},
	}),
	withStyles(styles)
)

export default enhance(TimeFrameFilter)
